import type { WidgetConfig } from '@examdojo/core/widget';
import { ContentBlockType, WidgetBlock } from '../../../model';

export const DEFAULT_WIDGET_CONFIG = {
  id: 'default-widget',
  type: 'quadratic-function',
  params: { a: 1, b: 0, c: -4 },
  display: {
    grid: false,
    axes: true,
    vertex: { enabled: true, label: { show: true, format: 'name' } },
    roots: { enabled: true, label: { show: true, format: 'name' } },
  },
  behavior: {
    features: {
      sliders: false,
      interaction: true,
    },
  },
} as const satisfies WidgetConfig;

export const DEFAULT_WIDGET_PROPS: Omit<WidgetBlock, 'id'> = {
  type: ContentBlockType.Widget,
  widget_type: 'quadratic-function',
  config: DEFAULT_WIDGET_CONFIG,
};
